// Données structurées schema.org (JSON-LD) partagées entre les pages
import site from './site.json';
import reviews from './reviews';

const { business } = site;
const BUSINESS_ID = `${site.url}/#business`;

export const localBusinessSchema = () => ({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": BUSINESS_ID,
    "name": business.name,
    "legalName": business.legalName,
    "description": business.description,
    "url": site.url,
    "logo": business.logo,
    "image": business.image,
    "telephone": business.telephone,
    "email": business.email,
    "foundingDate": business.foundingDate,
    "identifier": { "@type": "PropertyValue", "propertyID": "SIRET", "value": business.siret },
    "address": { "@type": "PostalAddress", ...business.address },
    "openingHours": business.openingHours,
    "priceRange": "Gratuit ou sur devis",
    "areaServed": site.cities.map((city) => ({ "@type": "City", "name": city.name })),
    "sameAs": business.sameAs,
    "knowsAbout": ["Débarras", "Vide-maison", "Débarras après succession", "Débarras de cave", "Débarras de grenier", "Tri et revalorisation d'objets"],
    "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de débarras",
        "itemListElement": [
            "Débarras de maison",
            "Débarras d'appartement",
            "Débarras de cave et grenier",
            "Débarras après succession",
            "Débarras de locaux professionnels",
        ].map((name) => ({ "@type": "Offer", "itemOffered": { "@type": "Service", "name": name } })),
    },
    "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": (reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length).toFixed(1),
        "reviewCount": reviews.length,
        "bestRating": 5,
        "worstRating": 1,
    },
});

// Service de débarras rattaché à une ville, relié à l'entreprise par son @id
export const cityServiceSchema = (city, url) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `Débarras à ${city.name}`,
    "serviceType": "Débarras",
    "url": url,
    "provider": { "@id": BUSINESS_ID, "@type": "LocalBusiness", "name": business.name, "telephone": business.telephone },
    "areaServed": { "@type": "City", "name": city.name, "postalCode": city.postalCode },
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "EUR", "description": "Débarras gratuit si les objets sont revendables, sinon devis gratuit" },
});

export const faqSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((item) => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": { "@type": "Answer", "text": item.answer },
    })),
});

// items : [{ name, path }] depuis l'accueil
export const breadcrumbSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": `${site.url}${item.path}`,
    })),
});
